<template>
  <div>
    <v-card :class="$style.widget">
      <div :class="$style.widget_title">
        <span class="display-3">Лимиты по договору</span>
      </div>

      <div class="d-flex flex-column justify-space-between my-4">
        <table>
          <thead>
            <tr>
              <th>Организация</th>
              <th>№ Договора</th>
              <th>Лимит по договору</th>
              <th>Остаток лимита</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in contracts"
              :key="item.contract"
              :class="$style.table_row"
            >
              <td
                :class="$style.first_cell"
              >
                <div :class="$style.row_wrapper">
                  <span>{{ item.organization || '' }}</span>
                  <span :class="$style.contract_number">{{ item.number_contract }}</span>
                </div>
              </td>
              <td>{{ item.number_contract || '' }}</td>
              <td>{{ item.limit | currency_rub }}</td>
              <td :class="$style.last_cell">{{ item.limit_balance | currency_rub }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-card>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { widgets_store } from '@/store';

const { state } = widgets_store;

@Component
export default class WidgetContractLimits extends Vue {
  get contracts() {
    return state.widgets.limit_not_resident;
  }
}
</script>

<style module lang="scss">
.widget {
  border: solid 1px black;
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 100%;
  box-sizing: border-box;

  .widget_title {
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    color: #13141C;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;

    th, td {
      padding: 8px 16px;
    }

    td {
      text-align: left;
      font-size: 14px;
      font-family: "TT Firs Neue", sans-serif !important;
    }

    td:nth-child(3),
    td:nth-child(4) {
      font-weight: 600;
      text-align: right;
    }

    th {
      text-align: left;
      color: #696C86;
      font-weight: 400;
      font-size: 11px;
      text-transform: uppercase;
    }

    th:nth-child(3),
    th:nth-child(4) {
      text-align: right;
    }

    .table_row:nth-child(odd) {
      background-color: #F6F7FA;
    }

    .first_cell {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }

    .last_cell {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }

    .contract_number {
      display: none;
    }

    .row_wrapper {
      display: flex;
      flex-direction: column;
    }
  }

  @media (max-width: 599px) {
    table {
      th:nth-child(2),
      td:nth-child(2) {
        display: none;
      }

      .contract_number {
        display: block;
        color: #696C86;
      }
    }
  }
}

</style>
